import { destroy, post } from '@rails/request.js';

async function parseJson(response) {
  try {
    return await response.json;
  } catch {
    return null;
  }
}

function authRoute(path) {
  if (path.includes('/v2')) throw new Error('do not pass the /v2 prefix to this helper');
  if (path.includes('://')) throw new Error('path must be relative');
  if (!path.startsWith('/')) path = `/${path}`;

  return `/v2${path}`;
}

async function authPost(path, json) {
  const response = await post(authRoute(path), { body: json, responseKind: 'json' });
  const body = await parseJson(response);

  return { response, payload: body?.data ?? null, validations: body?.validations ?? null, errors: body?.errors ?? null };
}

// Not under /v2: the desktop OAuth endpoints live on the root origin so the
// intent nonce lands in the same session cookie /desktop/oauth/session reads.
export async function createDesktopSigninIntent() {
  const response = await post('/desktop/oauth/signin_intent', { responseKind: 'json' });
  const body = await parseJson(response);

  return { response, payload: body?.data ?? null };
}

export function requestEmailLoginCode({ email, signupInvitationCode }) {
  return authPost('/auth/email_code', {
    email,
    ...(signupInvitationCode ? { signup_invitation_code: signupInvitationCode } : {}),
  });
}

export function verifyEmailLoginCode({ email, code, timeZone }) {
  return authPost('/auth/email_code/verify', { email, code, time_zone: timeZone });
}

export function completeGoogleOauthSignup({ signupInvitationCode }) {
  return authPost('/auth/google_oauth_signup', { signup_invitation_code: signupInvitationCode });
}

export function completeEmailSignup({ signupInvitationCode }) {
  return authPost('/auth/email_signup', { signup_invitation_code: signupInvitationCode });
}

export function restoreSignupInviteUrl({ inviteUrl }) {
  return authPost('/auth/invite_url', { invite_url: inviteUrl });
}

// Abandons the pending signup server-side so a reload of /login stops asking for
// a code. Best effort: the UI leaves the invitation form either way.
export function cancelGoogleOauthSignup() {
  return destroy(authRoute('/auth/google_oauth_signup'), { responseKind: 'json' }).catch(() => null);
}

export function cancelEmailSignup() {
  return destroy(authRoute('/auth/email_signup'), { responseKind: 'json' }).catch(() => null);
}
